// pl_pms_reservations.ts
// Tłumaczenia dla PMS.Reservations.tsx i PMS.Reservations.Table.tsx

export const plPmsReservations = {

  summary: {
    total: "<strong>{{count}}</strong> łącznie",
    checkedIn_one: "<strong>{{count}}</strong> zameldowany",
    checkedIn_few: "<strong>{{count}}</strong> zameldowanych",
    checkedIn_many: "<strong>{{count}}</strong> zameldowanych",
    checkedIn_other: "<strong>{{count}}</strong> zameldowanego",
    arrivingToday_one: "<strong>{{progress}}</strong> przyjazd dzisiaj",
    arrivingToday_few: "<strong>{{progress}}</strong> przyjazdy dzisiaj",
    arrivingToday_many: "<strong>{{progress}}</strong> przyjazdów dzisiaj",
    arrivingToday_other: "<strong>{{progress}}</strong> przyjazdu dzisiaj",
  },
  wizard: {
    review: {
      documentChecked: "Dokument sprawdzony",
      vipLevel: "Poziom VIP",
      marketing: "Zgoda marketingowa",
      agreed: "Wyrażona",
      declined: "Odmowa",
      extras: "Dodatki",
      cityTax: "Opłata miejscowa",
      deposit: "Zaliczka",
      blockPackages: "Pakiety bloku",
    },
    selectedRooms_one: "Wybrano: {{count}} pokój.",
    selectedRooms_few: "Wybrano: {{count}} pokoje.",
    selectedRooms_many: "Wybrano: {{count}} pokoi.",
    selectedRooms_other: "Wybrano: {{count}} pokoju.",
    suitableRooms_one: "Pokaż tylko pokoje dla {{count}} gościa",
    suitableRooms_few: "Pokaż tylko pokoje dla {{count}} gości",
    suitableRooms_many: "Pokaż tylko pokoje dla {{count}} gości",
    suitableRooms_other: "Pokaż tylko pokoje dla {{count}} gościa",
    groupRoomsSummary: "Grupa · {{rooms}}: {{numbers}}",
    groupOccupancyHint: "Xentros automatycznie rozdziela gości między pokoje. Możesz zmienić przydział, ale łączne liczby muszą pozostać takie same: dorośli: {{adults}}, dzieci: {{children}}.",
  },

  title:     "Rezerwacje",
  search:    "Szukaj gościa lub ID...",

  // ── Akcje ─────────────────────────────────────────────────────────────────
  actions: {
    newReservation:     "Nowa rezerwacja",
    modifyReservation:  "Modyfikuj rezerwację",
    modify:             "Modyfikuj",
    cancelReservation:  "Anuluj rezerwację",
    confirmCancellation:"Potwierdź anulowanie",
    save:               "Zapisz",
    saving:             "Zapisywanie...",
    cancelling:         "Anulowanie...",
  },

  // ── Filtry statusów ───────────────────────────────────────────────────────
  status: {
    all:        "Wszystkie",
    confirmed:  "Potwierdzona",
    inHouse:    "Zameldowany",
    checkedOut: "Wymeldowany",
    cancelled:  "Anulowana",
    noShow:     "Nieobecny",
    pending:    "Oczekująca",
    waitlist:   "Lista oczekujących",
    planned:    "Planowana",
    completed:  "Zakończona",
    booked:     "Zarezerwowana",
    active:     "Aktywna",
    blocked:    "Zablokowana",
    departing:  "Odjeżdża dziś",
    authorized: "Autoryzowana",
    captured:   "Zarejestrowana",
    inProgress: "W trakcie",
  },

  // ── Typy rezerwacji ───────────────────────────────────────────────────────
  type: {
    individual: "Indywidualna",
    group:      "Grupowa",
    shared:     "Współdzielona",
    direct:     "Bezpośrednia",
  },

  // ── Pola formularza ───────────────────────────────────────────────────────
  fields: {
    guest:      "Gość",
    room:       "Pokój",
    checkIn:    "Zameldowanie",
    checkOut:   "Wymeldowanie",
    nights:     "Noce",
    adults:     "Dorośli",
    children:   "Dzieci",
    rate:       "Stawka",
    total:      "Łącznie",
    deposit:    "Kaucja",
    balance:    "Saldo",
    notes:      "Notatki",
  },

  // ── Sekcja historii ───────────────────────────────────────────────────────
  history: {
    title:      "Historia rezerwacji",
    auditTrail: "Ścieżka audytu dla tej rezerwacji.",
    captured:   "Zarejestrowane z zarządzania rezerwacjami.",
  },

  // ── Grupy rezerwacji ──────────────────────────────────────────────────────
  groups: {
    title:           "Grupy i wydarzenia",
    summary:         "Podsumowanie grupy",
    create:          "Utwórz grupę",
    edit:            "Edytuj grupę",
    save:            "Zapisz grupę",
    newReservation:  "Nowa rezerwacja grupowa",
    editReservation: "Edytuj rezerwację grupową",
    groupedRooms:    "Pokoje grupowe",
    linkedEvents:    "Powiązane wydarzenia",
    primaryEvent:    "Główne wydarzenie",
    setPrimary:      "Ustaw jako główne",
    masterDetails:   "Szczegóły główne i kontakt pierwotny.",
    optionalEvents:  "Opcjonalne wydarzenia powiązane z rezerwacją grupową.",
    editInline:      "Edytuj szczegóły rezerwacji w miejscu bez opuszczania przestrzeni roboczej.",
    createTrack:     "Twórz i śledź zgrupowane rezerwacje i powiązane wydarzenia w jednym widoku.",
    saved:           "Rezerwacja grupowa zapisana",
    updated:         "Rezerwacja grupowa zaktualizowana",
  },

  // ── Overbooking ───────────────────────────────────────────────────────────
  overbooking: "Kontrola nadkompletowania",

  // ── Lista oczekujących ────────────────────────────────────────────────────
  waitlistMissingGuest: "Wpis na listę oczekujących nie zawiera profilu gościa.",

  // ── Typy wydarzeń ─────────────────────────────────────────────────────────
  eventTypes: {
    meeting:       "Spotkanie",
    conference:    "Konferencja",
    banquet:       "Bankiet",
    wedding:       "Wesele",
    corporateEvent:"Wydarzenie firmowe",
    other:         "Inne",
  },

  // ── Komunikaty ────────────────────────────────────────────────────────────
  messages: {
    saved:                "Rezerwacja zaktualizowana",
    cancelled:            "Rezerwacja anulowana",
    correctionRequired:   "Proszę poprawić zaznaczone błędy w rezerwacji.",
    groupCorrectionRequired:"Proszę poprawić zaznaczone błędy w rezerwacji grupowej.",
    noEmail:              "Brak adresu e-mail odbiorcy dla tej rezerwacji.",
    confirmationSent:     "Wysłano e-mail z potwierdzeniem.",
    depositCaptured:      "Kaucja zarejestrowana.",
  },

} as const;

export default plPmsReservations;
